/**
 * A integração DV360 (D-191, emendada pela D-192; §3, §5.1, §5.3, §5.6 do plano do pacote Campanhas + DV360; P-33,
 * P-34, P-41, P-57, P-58; DS-667, DS-668, DS-684) — contrato próprio, fora de `campanhas.ts`.
 *
 * O vínculo (D-192, DS-684). A campanha acha as Campaigns numa lista pesquisável, escolhe, confere e confirma; o
 * Advertiser é só a identidade técnica da Campaign, que o servidor resolve pelo catálogo que ELE leu do Google, e nunca
 * vem do corpo. Nenhuma destas rotas chama o Google dentro da requisição: a descoberta lê o catálogo do Partner que a
 * API mantém em memória (e o manda reler quando falta ou venceu), e a confirmação confere contra ele.
 *
 *   GET  /campanhas/:id/dv360/campaigns-disponiveis?q&status&pagina&atualizar
 *        → 200 `CampaignsDv360Disponiveis` (a entrada é `EntradaDaDescobertaDv360`). As guardas vêm ANTES do catálogo,
 *        nesta ordem, e quem não pode vincular não dispara chamada nenhuma: `midia · editar_proprio`, a entidade ativa, a
 *        campanha dela (404), quem edita os custos (403), 422 `dv360.integracao_inativa`, 422 `dv360.entidade_sandbox`,
 *        422 `campanha.cancelada` ou `dv360.status_nao_vincula`, 503 `dv360.partner_nao_configurado`. Passadas as
 *        guardas, responde 200 em TODO estado do catálogo (lendo, conferindo, completo, parcial, falhou), com a classe da
 *        falha no corpo. Não grava nada e não tem trilha.
 *   GET  /campanhas/:id/dv360/vinculos                     → `VinculosDv360DaCampanha`           (`midia · ver`)
 *   POST /campanhas/:id/dv360/vinculos                     → 201 `VinculosDv360DaCampanha`       (quem edita os custos;
 *        corpo `EntradaDeVinculoDv360` = `{campaignIds}`; o vínculo nasce AGUARDANDO CONFERÊNCIA e nunca aparece como
 *        confirmado antes da conferência do Google, P-34; a parte comercial do pedido não entra: sem ela, vincula do
 *        mesmo jeito, e nada dela é gravado no vínculo — D-193 (7))
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/desvincular → 201 `VinculosDv360DaCampanha`   (quem edita os custos,
 *        em qualquer status, com a integração ligada ou não)
 *
 * As recusas do vínculo, nomeadas (`RECUSAS_DO_VINCULO_DV360`) e no campo do corpo: 422 `dv360.integracao_inativa`,
 * `dv360.entidade_sandbox`, `campanha.cancelada`, `dv360.status_nao_vincula`, `dv360.campaign_id_invalido` e
 * `dv360.campaign_repetida` (`campaignIds.N`), `dv360.limite_de_campaigns` (`campaignIds`),
 * `dv360.campaign_fora_da_lista` (`campaignIds.N`: o catálogo deste servidor não a conhece — depois de um reinício, por
 * exemplo; a tela volta a consultar) e `dv360.lista_desatualizada` (`campaignIds.N`: a lista do Advertiser dela foi lida
 * há mais de 60 min); 409 `dv360.campaign_ja_vinculada` (`campaignIds.N`), também na corrida do índice único, com a
 * frase neutra quando a outra campanha é de outra entidade; 503 `dv360.partner_nao_configurado`. Em todas, nada é
 * gravado. O corpo com `anuncianteId` ou `advertiserId` é 400 (o contrato é `.strict()`).
 *
 * Os IDs do Google viajam como TEXTO (passam de 2^53).
 *
 * A ingestão (E7b, parte B; P-36 a P-41, §6 C5; DS-671): o worker agenda (`FILA_PLANEJAR_DV360`) e publica a varredura
 * (`FILA_VARRER_DV360`), que a API consome com a credencial. Só as Campaigns vinculadas são coletadas. Os atos manuais,
 * sob a campanha, NUNCA chamam o Google na requisição: abrem ou mudam o que a varredura faz.
 *
 *   POST /campanhas/:id/dv360/sincronizar                          → 201 `SincronizacoesDv360DaCampanha` (quem edita a
 *        campanha; integração ativa; sem espera fixa desde a revisão de 22/10/2026: a aberta volta como está, e a nova só
 *        abre com vaga no teto do dia fora das reservas da diária e das faixas intradiárias de hoje — a que não cabe é
 *        nomeada em `foraDoTeto`, e nenhuma é 422 `dv360.teto_do_dia`; `dv360.sem_vinculo`;
 *        `dv360.sincronizacao_encerrada`; a Campaign suspensa fica de
 *        fora e é nomeada em `suspensas`, e todas suspensas é `dv360.suspensa`: a saída é "Tentar de novo". Desde a
 *        revisão da parte E (RE-PC-04, DS-671 (t)), a Campaign com a coleta encerrada ENTRA: a sincronização dela só a
 *        confere — ainda sumida, fecha `encerrada`/`coleta_encerrada` sem pedir dado; de volta, a coleta retoma)
 *   POST /campanhas/:id/dv360/retomar-acompanhamento               → 201 `RetomadaDoAcompanhamentoDv360` (quem edita os
 *        custos; integração ativa; `dv360.acompanhamento_aberto` na campanha sem fim delimitado)
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/reconferir       → 201 `SincronizacoesDv360DaCampanha` (quem edita os
 *        custos; integração ativa. Desde a parte E (VT2-PC-04, DS-671 (r)) vale também na coleta encerrada: a
 *        conferência relê a Campaign e, se ela voltou, a coleta retoma)
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/encerrar-coleta  → 201 `VinculosDv360DaCampanha` (quem edita os
 *        custos; integração ativa; motivo; só a Campaign confirmada que passou a dar 404: `dv360.encerrar_so_nao_encontrada`;
 *        com o encerramento vigente: `dv360.coleta_ja_encerrada`. Um por episódio de 404: a Campaign que retomou e some
 *        de novo recebe outro — revisão da parte E, RE-PC-02, DS-671 (t))
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/ampliar-historico → 201 `AmpliacaoDeHistoricoDv360` (quem edita os
 *        custos; integração ativa; `dv360.ainda_nao_confirmado`, `dv360.ampliar_nao_recua`, `dv360.ampliar_alem_de_24_meses`,
 *        `dv360.suspensa`)
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/tentar-de-novo   → 201 `SincronizacoesDv360DaCampanha` (quem edita os
 *        custos; integração ativa; `dv360.nao_suspensa`)
 *   POST /campanhas/:id/dv360/vinculos/:vinculoId/reprocessar      → 201 `SincronizacoesDv360DaCampanha` (P-41, E7b parte C:
 *        `midia · editar_todos`; integração ativa; o período INTEIRO é pedido de novo, coberto ou não; DS-672. Recusas
 *        422: `dv360.periodo_invalido` (`de`), `dv360.periodo_no_futuro` (`ate`, o dia corrente nunca entra),
 *        `dv360.periodo_alem_de_24_meses` (`de`), `dv360.periodo_longo_demais` (`de`, mais de 12 janelas de 32 dias),
 *        `dv360.ainda_nao_confirmado`, `dv360.coleta_encerrada`, `dv360.suspensa`, `dv360.sincronizacao_encerrada`,
 *        `dv360.sincronizacao_em_curso`)
 */
import { z } from 'zod'
import {
  ESTADOS_DA_DESCOBERTA_DV360,
  FALHAS_DA_DESCOBERTA_DV360,
  FILTROS_DE_STATUS_DA_DESCOBERTA_DV360,
  LIMITES_DV360,
  MOTIVOS_SEM_VINCULO_DV360,
  SITUACOES_NA_DESCOBERTA_DV360,
  STATUS_NA_DESCOBERTA_DV360,
} from '@dv/domain'
import { dataNominal, uuid } from './comum.js'
import { referenciaDeUsuario } from './usuarios.js'

export { ehIdDoGoogleDv360, type MotivoSemVinculoDv360 } from '@dv/domain'

/** Um ID do Google: texto (o domínio confere dígitos, sem zero à esquerda, até int64, com a recusa nomeada). */
const idDoGoogle = z.string().max(40)

/** Um aviso que acompanha o ato, sem bloquear: a frase pronta e o código para a tela. */
export const avisoDv360 = z.object({
  codigo: z.enum(['moeda_fora_do_catalogo', 'moeda_divergente', 'retomada_implicita']),
  texto: z.string(),
})
export type AvisoDv360 = z.infer<typeof avisoDv360>

/** Por que quem lê não pode vincular (P-58): o catálogo único do domínio, o mesmo da ficha da campanha. */
export const motivoSemVinculoDv360 = z.enum(MOTIVOS_SEM_VINCULO_DV360)

/** As recusas nomeadas da descoberta e do vínculo (o `rule` do campo do envelope de erro), para a API e a tela. */
export const RECUSAS_DO_VINCULO_DV360 = [
  'dv360.integracao_inativa',
  'dv360.entidade_sandbox',
  'campanha.cancelada',
  'dv360.status_nao_vincula',
  'dv360.partner_nao_configurado',
  'dv360.sem_campaign',
  'dv360.campaign_id_invalido',
  'dv360.campaign_repetida',
  'dv360.limite_de_campaigns',
  'dv360.campaign_fora_da_lista',
  'dv360.lista_desatualizada',
  'dv360.campaign_ja_vinculada',
] as const
export type RecusaDoVinculoNoContratoDv360 = (typeof RECUSAS_DO_VINCULO_DV360)[number]

// ------------------------------------------------------------------------------------------------ a descoberta (D-192)

/**
 * A entrada da descoberta, na query string: o termo (nome, parte do nome ou ID; vazio, todas), o status, a página (de
 * 50) e o "Atualizar lista" (`atualizar=1`: força um ciclo, no máximo a cada 60 s por processo; com um ciclo em curso,
 * não faz nada).
 */
export const entradaDaDescobertaDv360 = z.object({
  q: z.string().max(200).default(''),
  status: z.enum(FILTROS_DE_STATUS_DA_DESCOBERTA_DV360).default('todas'),
  pagina: z.coerce.number().int().min(1).max(10_000).default(1),
  atualizar: z.enum(['0', '1']).default('0').transform((v) => v === '1'),
})
export type EntradaDaDescobertaDv360 = z.input<typeof entradaDaDescobertaDv360>

/**
 * Uma Campaign da lista, só com a identificação (DS-684 (d), (k)): o nome, o ID, o status (ativa ou pausada; a
 * ARCHIVED nunca vem), o período planejado, o nome do Advertiser como texto auxiliar, a moeda (só para o aviso do
 * Conferir) e a situação para QUEM PEDE. Nunca o advertiserId, custo, métrica, status bruto ou payload do Google.
 * `detentor` só vem na `em_outra_campanha` (a outra campanha da MESMA entidade: código e rótulo do status); a
 * `indisponivel` (vinculada em outra entidade) não diz nada dela.
 */
export const campaignDisponivelDv360 = z.object({
  campaignId: idDoGoogle,
  nome: z.string(),
  status: z.enum(STATUS_NA_DESCOBERTA_DV360),
  inicio: dataNominal.nullable(),
  fim: dataNominal.nullable(),
  advertiserNome: z.string(),
  moeda: z.string(),
  /** A moeda do Advertiser difere da campanha: vincular pode, com aviso; a fonte dv360, não (P-57). */
  moedaDivergente: z.boolean(),
  /** A moeda está no catálogo de moedas do sistema; fora dele, o custo aparece na moeda dele e nunca é fonte do gasto. */
  moedaNoCatalogo: z.boolean(),
  situacao: z.enum(SITUACOES_NA_DESCOBERTA_DV360),
  /** A campanha da mesma entidade que já tem a Campaign: o código e o rótulo do status (`rotuloDoStatusDaCampanha`). */
  detentor: z.object({ codigo: z.string(), status: z.string() }).strict().optional(),
}).strict().refine((c) => (c.detentor !== undefined) === (c.situacao === 'em_outra_campanha'), {
  message: 'o detentor vem só na Campaign vinculada a outra campanha da mesma entidade',
  path: ['detentor'],
})
export type CampaignDisponivelDv360 = z.infer<typeof campaignDisponivelDv360>

/**
 * A resposta da descoberta (DS-684 (a) a (d)), `.strict()`:
 *   · `catalogo`: o estado do catálogo deste servidor — `lendo`, `conferindo`, `completo`, `parcial` ou `falhou`; os
 *     Advertisers conferidos (lidos dentro da validade) de `total` (nulo antes da lista de Advertisers); `lidoEm`, a
 *     leitura mais antiga (a hora que a frase cita; sem Advertiser no Partner, a da lista de Advertisers; o `completo`
 *     sempre a tem); a classe da falha (só no parcial e no falhou); e `atualizarDisponivelEm`, que fala SÓ do intervalo
 *     de 60 s do "Atualizar lista": o instante em que ele deixa de segurar, ou nulo quando ele não segura — com um ciclo
 *     em curso o pedido não faz nada mesmo assim, e a tela desabilita "Atualizar" também em `lendo` e `conferindo`. A
 *     frase definitiva "nenhuma encontrada" só existe com `completo`;
 *   · `contexto`: a campanha, o pedido e a entidade do passo Conferir;
 *   · a página da busca, as já vinculadas da campanha e o limite (20).
 */
export const campaignsDv360Disponiveis = z.object({
  catalogo: z.object({
    estado: z.enum(ESTADOS_DA_DESCOBERTA_DV360),
    conferidos: z.number().int().nonnegative(),
    total: z.number().int().nonnegative().nullable(),
    /** Instante ISO 8601 (UTC). */
    lidoEm: z.string().nullable(),
    falha: z.enum(FALHAS_DA_DESCOBERTA_DV360).nullable(),
    /** Instante ISO 8601 (UTC): só o intervalo de 60 s; nulo quando ele não segura (com ciclo em curso, nada acontece). */
    atualizarDisponivelEm: z.string().nullable(),
  }).strict().refine((c) => c.estado !== 'completo' || c.lidoEm !== null, {
    message: 'o completo sempre cita a hora da lista',
    path: ['lidoEm'],
  }),
  contexto: z.object({
    campanha: z.object({ codigo: z.string(), nome: z.string() }).strict(),
    pedidoCodigo: z.string(),
    entidade: z.object({ nome: z.string() }).strict(),
  }).strict(),
  campaigns: z.array(campaignDisponivelDv360),
  total: z.number().int().nonnegative(),
  pagina: z.number().int().min(1),
  porPagina: z.literal(LIMITES_DV360.campaignsPorPaginaDaDescoberta),
  /** Quantas Campaigns a campanha já tem vinculadas (não anuladas), e o limite. */
  vinculadas: z.number().int().nonnegative(),
  limite: z.literal(LIMITES_DV360.campaignsPorCampanha),
}).strict()
export type CampaignsDv360Disponiveis = z.infer<typeof campaignsDv360Disponiveis>

// ------------------------------------------------------------------------------------------------ o vínculo

/**
 * Vincular as Campaigns confirmadas no diálogo, tudo ou nada (§3.1, P-33; D-192): só os IDs, de 1 a 20. O Advertiser,
 * o nome, a moeda e o fuso vêm do catálogo do servidor, nunca daqui; `.strict()`, então `anuncianteId` ou
 * `advertiserId` no corpo é 400. As recusas estão no cabeçalho deste arquivo.
 */
export const entradaDeVinculoDv360 = z.object({
  campaignIds: z.array(idDoGoogle).min(1).max(LIMITES_DV360.campaignsPorCampanha),
}).strict()
export type EntradaDeVinculoDv360 = z.input<typeof entradaDeVinculoDv360>

/**
 * O estado da CONFERÊNCIA do vínculo pelo Google (P-34): `aguardando_conferencia` desde o ato até a 1ª sincronização,
 * que o confirma ou dá `nao_encontrado`. Vínculo criado não é vínculo conferido (DS-684 (f)).
 */
export const estadoDoVinculoDv360 = z.enum(['aguardando_conferencia', 'confirmado', 'nao_encontrado'])

/**
 * Um vínculo não anulado, com o que `midia · ver` vê (P-20): os IDs, a identidade técnica gravada no ato (o nome do
 * Advertiser como texto auxiliar e a moeda), o estado da conferência pelo Google e quem vinculou e quando
 * (`vinculadoPor`, `vinculadoEm`: a autoria, que a célula Vínculo mostra). O nome da Campaign é leitor de custo e vem do
 * retrato, na leitura do bloco "Mídia · DV360".
 */
export const vinculoDv360 = z.object({
  id: uuid,
  campaignId: z.string(),
  advertiserId: z.string(),
  anuncianteNome: z.string(),
  moeda: z.string(),
  moedaDivergente: z.boolean(),
  estado: estadoDoVinculoDv360,
  conferidoEm: z.string().nullable(),
  vinculadoPor: referenciaDeUsuario,
  vinculadoEm: z.string(),
})
export type VinculoDv360 = z.infer<typeof vinculoDv360>

export const vinculosDv360DaCampanha = z.object({
  vinculos: z.array(vinculoDv360),
  /** Os avisos do ato que acabou de acontecer (vazio na leitura). */
  avisos: z.array(avisoDv360),
  /** Por que não pode vincular (P-58), o mesmo da ficha; nulo quando pode. */
  motivoSemVinculo: motivoSemVinculoDv360.nullable(),
  capacidades: z.object({
    /** Quem edita os custos, integração ativa, entidade fora do Sandbox, status que vincula (§5.5). */
    podeVincular: z.boolean(),
    /** Quem edita os custos, em qualquer status, com a integração ligada ou não. */
    podeDesvincular: z.boolean(),
  }),
})
export type VinculosDv360DaCampanha = z.infer<typeof vinculosDv360DaCampanha>

/** Desvincular: o motivo (10 a 500; `dv360.motivo_obrigatorio`). Vale para todo o histórico e para o portal. */
export const entradaDeDesvinculoDv360 = z.object({ motivo: z.string().max(2000) })
export type EntradaDeDesvinculoDv360 = z.input<typeof entradaDeDesvinculoDv360>

// ------------------------------------------------------------------------------------------------ a ingestão (P-36 a P-41)

/**
 * A fila do PLANEJADOR, no worker: dois agendamentos no relógio de São Paulo — a diária às 09:30 (só com
 * `DV_DV360_ATIVO` e o parâmetro `dv360.sincronizacao_diaria_ativa` = 'true') e a varredura a cada 5 min (só com
 * `DV_DV360_ATIVO`). O planejador não fala com o Google nem recebe credencial: publica na fila abaixo.
 */
export const FILA_PLANEJAR_DV360 = 'dv-dv360-planejar'

/** A fila da VARREDURA, consumida pela API (a que tem a credencial), registrada em `principal()`. */
export const FILA_VARRER_DV360 = 'dv-dv360-varrer'

export const FUSO_DA_SINCRONIZACAO_DV360 = 'America/Sao_Paulo'
/** A diária às 09:30 de São Paulo (P-36). */
export const CRON_DA_DIARIA_DV360 = '30 9 * * *'
/**
 * A mesma hora, como a varredura de 5 min a lê (HH:mm em São Paulo): daí em diante, a diária do dia que ainda não abriu
 * (a Campaign estava com outra sincronização aberta, ou o job das 09:30 esgotou as retentativas) abre assim que a
 * Campaign fica livre (DS-671 (j)). O teste do contrato prende as duas ao mesmo horário.
 */
export const HORA_DA_DIARIA_DV360 = '09:30'
/** A varredura a cada 5 min (P-37). */
export const CRON_DA_VARREDURA_DV360 = '*/5 * * * *'
/** O único parâmetro em banco (P-43): só o literal 'true' liga a diária. */
export const PARAMETRO_SINCRONIZACAO_DIARIA_DV360 = 'dv360.sincronizacao_diaria_ativa'

export const cadenciaDoDv360 = z.enum(['diaria', 'varredura'])
export type CadenciaDoDv360 = z.infer<typeof cadenciaDoDv360>

/** O job do planejador e o da varredura levam só a cadência: nada de credencial, período nem escopo. */
export const jobDoDv360 = z.object({ cadencia: cadenciaDoDv360 })
export type JobDoDv360 = z.infer<typeof jobDoDv360>

export const origemDaSincronizacaoDv360 = z.enum(['diaria', 'manual', 'historico', 'conferencia', 'reprocessar'])
export const estadoDaSincronizacaoDv360 = z.enum(['aberta', 'concluida', 'falhou', 'adiada', 'suspensa', 'encerrada'])

/** Uma sincronização de uma Campaign (uma aberta por vez, P-37). O motivo é nomeado, nunca valor. */
export const sincronizacaoDv360 = z.object({
  id: uuid,
  campaignId: z.string(),
  origem: origemDaSincronizacaoDv360,
  estado: estadoDaSincronizacaoDv360,
  motivo: z.string().nullable(),
  /** Instantes ISO 8601 (UTC). */
  abertaEm: z.string(),
  fechadaEm: z.string().nullable(),
})
export type SincronizacaoDv360 = z.infer<typeof sincronizacaoDv360>

/**
 * O que "Sincronizar agora", "Reconferir" e "Tentar de novo" devolvem: as sincronizações abertas pelo ato (ou já abertas).
 * `suspensas` (só o "Sincronizar agora"): as Campaigns que o ato deixou de fora porque a coleta delas está suspensa por
 * limite, validação ou desenho — a saída é "Tentar de novo", de quem edita os custos (§6 C5; DS-671 (k)).
 * `foraDoTeto` (só o "Sincronizar agora", e só quando há): as que ficaram de fora porque o que resta do teto do dia está
 * reservado para a diária e as faixas intradiárias de hoje; nada foi aberto para elas.
 */
export const sincronizacoesDv360DaCampanha = z.object({
  sincronizacoes: z.array(sincronizacaoDv360),
  suspensas: z.array(idDoGoogle).optional(),
  foraDoTeto: z.array(idDoGoogle).optional(),
})
export type SincronizacoesDv360DaCampanha = z.infer<typeof sincronizacoesDv360DaCampanha>

/** "Encerrar coleta" (P-34): o motivo, de 10 a 500 (`dv360.motivo_obrigatorio`). */
export const entradaDeEncerramentoDeColetaDv360 = z.object({ motivo: z.string().max(2000) })
export type EntradaDeEncerramentoDeColetaDv360 = z.input<typeof entradaDeEncerramentoDeColetaDv360>

/** "Ampliar histórico" (§6 C5): o novo início da carga, anterior ao atual e nunca antes de D − 24 meses. */
export const entradaDeAmpliacaoDeHistoricoDv360 = z.object({ inicio: dataNominal })
export type EntradaDeAmpliacaoDeHistoricoDv360 = z.input<typeof entradaDeAmpliacaoDeHistoricoDv360>

export const ampliacaoDeHistoricoDv360 = z.object({
  inicioCarga: dataNominal,
  /** Quantas janelas de 32 dias a carga ainda pede a partir do novo início. */
  janelas: z.number().int(),
  sincronizacao: sincronizacaoDv360,
})
export type AmpliacaoDeHistoricoDv360 = z.infer<typeof ampliacaoDeHistoricoDv360>

/** "Reprocessar período" (P-41): o período a pedir de novo, em dias nominais no fuso do Advertiser. */
export const entradaDeReprocessamentoDv360 = z.object({ de: dataNominal, ate: dataNominal })
export type EntradaDeReprocessamentoDv360 = z.input<typeof entradaDeReprocessamentoDv360>

/** "Retomar acompanhamento" (P-40): até quando a sincronização da campanha vai agora. */
export const retomadaDoAcompanhamentoDv360 = z.object({ acompanharAte: dataNominal })
export type RetomadaDoAcompanhamentoDv360 = z.infer<typeof retomadaDoAcompanhamentoDv360>

// ------------------------------------------------------------------------------------------------ a leitura "Mídia · DV360"

/**
 * A seção "Mídia · DV360" da ficha (E7b, parte C; §5.2, P-20, P-42, P-44, P-52, P-53; DS-672). NENHUMA destas rotas chama
 * o Google: tudo vem do que a ingestão gravou. Todas sob a campanha, com a entidade ativa (a de outra entidade é 404) e
 * `midia · ver`. Os textos obrigatórios da P-44 são da tela.
 *
 *   GET /campanhas/:id/dv360?de&ate                                   → `MidiaDv360DaCampanha` (o bloco inteiro)
 *   GET /campanhas/:id/dv360/campaigns/:campaignId/ios?de&ate         → `InsertionOrdersDv360DaCampaign`
 *   GET /campanhas/:id/dv360/ios/:ioId/line-items?pagina&busca&tipo&status&atividade&de&ate
 *                                                                     → `LineItemsDv360DoInsertionOrder` (50 por página)
 *   GET /campanhas/:id/dv360/serie?grao&escopo&de&ate                 → `SerieDv360` (até 366 pontos)
 *   GET /campanhas/:id/dv360/line-items/:liId/criativos               → `CriativosDv360DoLineItem`
 *   GET /campanhas/:id/dv360/criativos?pagina&busca&campaign&io&tipo&status → `CriativosDv360DoEscopo` (50 por página;
 *        parte E, VT2-PC-08: os filtros da seção — a Campaign, o IO, o tipo e o status no DV360 do LINE ITEM, os mesmos
 *        valores da rota dos line items —, todos opcionais, e o "usado em n" contado só entre os line items do recorte)
 *
 * LEITORES DE CUSTO (P-20, DS-278): sem `midia_custos_margem · ver`, os nomes de Campaign, IO, line item e criativo vêm
 * nulos, as quantias vêm nulas, a associação ao item e os alertas de GASTO não vêm, a busca não casa nome e a ordem é
 * por impressões; com a permissão e sem as flags de valores (as de Mídia e de custos), só as quantias vêm nulas (e a
 * ordem continua por impressões). IDs, estados, status técnico, cobertura, sincronização, impressões, cliques e CTR
 * vêm para quem vê a campanha.
 *
 * O recorte: `de` e `ate` juntos (`de` <= `ate`), ou nenhum (o Acumulado). Recusas 422: `dv360.recorte_invalido`
 * (`de`), `dv360.serie_longa_demais` (`de`, mais de 366 pontos), `dv360.escopo_invalido` (`escopo`),
 * `dv360.grao_invalido` (`grao`), `dv360.pagina_invalida` (`pagina`), `dv360.atividade_invalida` (`atividade`).
 * Campaign, IO, line item ou criativo fora das Campaigns confirmadas desta campanha é 404 (também como filtro dos
 * criativos: `campaign` e `io`; o IO de outra Campaign que a filtrada dá a lista vazia).
 */

/** Um custo na moeda dele (nunca convertido nem somado entre moedas); `valor` nulo para quem não vê as quantias. */
export const custoNaMoedaDv360 = z.object({ moeda: z.string(), valor: z.string().nullable() })
export type CustoNaMoedaDv360 = z.infer<typeof custoNaMoedaDv360>

/** Os totais de um escopo, dos MESMOS fatos vigentes (nunca soma de outro nível). */
export const totaisDv360 = z.object({
  /** Um subtotal por moeda, em ordem de código; arredondado UMA vez nas casas da moeda (ROUND_HALF_UP). */
  custos: z.array(custoNaMoedaDv360),
  /** Inteiros como texto (passam de 2^53). */
  impressoes: z.string(),
  cliques: z.string(),
  /** Σ cliques ÷ Σ impressões, em percentual com 2 casas; nulo sem impressões ("—"). */
  ctr: z.string().nullable(),
  /** Quantos fatos (Campaign, LI, dia) entraram: com fatos e custo zero é "R$ 0,00 apurado"; sem fatos, "sem veiculação". */
  fatos: z.number().int(),
})
export type TotaisDv360 = z.infer<typeof totaisDv360>

/**
 * Leitura aditiva: completos + último retrato disponível por Campaign/dia sem cobertura.
 * Os totais antigos mantêm a semântica de completos. Ausência é null; um relatório válido
 * sem atividade pode ter totais zero. Retrato nunca amplia a cobertura completa.
 */
export const leituraCompostaDv360 = z.object({
  totais: totaisDv360.nullable(),
  intervalo: z.object({ inicio: dataNominal, fim: dataNominal }).nullable(),
  dadosCompletosAte: dataNominal.nullable(),
  atualizadoEm: z.string().nullable(),
  geradoEm: z.string().nullable(),
  diasEmAtualizacao: z.array(dataNominal),
  /** Todos os retratos selecionados são do dia corrente nos respectivos fusos dos Advertisers. */
  dadosDeHoje: z.boolean(),
  fusos: z.array(z.string()),
  parcial: z.boolean(),
  atrasado: z.boolean(),
})
export type LeituraCompostaDv360 = z.infer<typeof leituraCompostaDv360>

export const intervaloDv360 = z.object({ inicio: dataNominal, fim: dataNominal })
export type IntervaloDv360 = z.infer<typeof intervaloDv360>

export const MOTIVOS_DOS_ALERTAS_DV360 = [
  'nao_encontrada', 'nao_encontrada_no_dv360', 'suspensa', 'falhas_seguidas', 'cota_em_dias_seguidos', 'relatorio_atrasado',
  'revisao_atrasada', 'historico_limitado', 'moeda_divergente', 'borda_quente', 'campaign_ativa_com_campanha_encerrada',
  'encerrada_com_campaign_ativa', 'gasto_antes_do_inicio_planejado', 'gasto_depois_do_fim_planejado', 'gasto_durante_pausa',
  'gasto_depois_da_conclusao', 'gasto_depois_do_cancelamento', 'media_cost_negativo',
  // Parte E (VT2-PC-04; P-34, §3.1; DS-671 (r) e (t)): a coleta que retomou porque a Campaign voltou ao DV360 — com o
  // "Encerrar coleta" vigente (detalhe `coleta_encerrada`) ou sem ele (a confirmada que deu 404 e voltou).
  'coleta_retomada',
  // E7b, o alerta da ausência (§4.6; DS-672 (x)): a linha vigente que sumiu de um relatório validado e ainda não foi
  // confirmada — com o detalhe `relatorio_sem_linhas` quando o relatório veio inteiro sem linhas onde antes havia.
  'ausencia_a_confirmar',
] as const

/**
 * Um alerta (§4.7, §6 C5): o MESMO que o aviso do catálogo da D-187 leva (P-42). `coleta` (vínculo, cobertura e
 * sincronização) para quem vê a campanha; `gasto` só para quem vê custos e margem. O texto não tem valores.
 */
export const alertaDv360 = z.object({
  /** Informação histórica preservada no detalhe; não conta como alerta acionável. */
  informativo: z.boolean().optional(),
  tipo: z.enum(['coleta', 'gasto']),
  motivo: z.enum(MOTIVOS_DOS_ALERTAS_DV360),
  /** Nulo no da campanha inteira (a sincronização encerrada no teto). */
  campaignId: z.string().nullable(),
  referencia: z.enum(['campaign', 'local']).nullable(),
  dias: z.array(dataNominal),
  /**
   * O sub-motivo nomeado: o da suspensão (`grande_demais`, `validacao`, `contrato_desenho`); na
   * `coleta_retomada`, `coleta_encerrada` quando a volta da Campaign retomou também um "Encerrar coleta" (nulo na volta
   * da Campaign que deu 404 sem o ato; revisão da parte E, RE-PC-03, DS-671 (t)); na `ausencia_a_confirmar`,
   * `relatorio_sem_linhas` quando um relatório veio inteiro sem linhas onde antes havia (nulo sem ele; DS-672 (x)).
   */
  detalhe: z.string().nullable(),
  texto: z.string(),
})
export type AlertaDv360 = z.infer<typeof alertaDv360>

export const situacaoDaSincronizacaoDv360 = z.enum([
  'aguardando_conferencia', 'nao_encontrada', 'encerrada', 'coleta_encerrada', 'suspensa', 'nao_encontrada_no_dv360',
  'carga', 'aguardando_relatorio', 'revisao_atrasada', 'falhou', 'adiada', 'aguardando_consulta', 'em_dia',
])

/** O estado da sincronização de uma Campaign, na precedência da tela (§5.2). */
export const estadoDaSincronizacaoNaFichaDv360 = z.object({
  situacao: situacaoDaSincronizacaoDv360,
  /** O motivo nomeado: o da suspensão, o da falha (`failed`, `expirado`, `validacao`…), o do adiamento (`cota`, `teto_diario`). */
  motivo: z.string().nullable(),
  /** Instante ISO: desde quando o relatório espera, quando a falha ou o adiamento fechou, quando a carga abriu. */
  desde: z.string().nullable(),
  /** A data que a frase cita: o fim delimitado ("Encerrada em"), o "desde" do 404, o dia da revisão atrasada. */
  dia: dataNominal.nullable(),
  /** Na carga histórica: "Carga k de n". */
  carga: z.object({ validadas: z.number().int(), total: z.number().int() }).nullable(),
  /**
   * A próxima tentativa automática (instante ISO): a semanal da suspensa por limite ou validação; no dia que falhou ou
   * foi adiado, a do ciclo seguinte — a meia-noite seguinte no fuso do Advertiser ou, com a diária ligada, as 09:30 de
   * São Paulo, a que vier primeiro ("Falha: <motivo>; próxima tentativa …", §4.6; DS-672 (c)).
   */
  proximaTentativaEm: z.string().nullable(),
})
export type EstadoDaSincronizacaoNaFichaDv360 = z.infer<typeof estadoDaSincronizacaoNaFichaDv360>

/** Uma Campaign vinculada (não anulada) como a seção a mostra. */
export const campaignDv360NaFicha = z.object({
  vinculoId: uuid,
  campaignId: z.string(),
  /** Do retrato (só da Campaign confirmada); leitor de custo (P-20). */
  nome: z.string().nullable(),
  advertiserId: z.string(),
  /** O nome do Advertiser gravado no vínculo (a identidade técnica, DS-684 (g)): texto auxiliar. */
  anuncianteNome: z.string(),
  moeda: z.string(),
  moedaDivergente: z.boolean(),
  /** O entityStatus com a data da leitura (P-44): nunca altera o status local. Nulo antes da primeira conferência. */
  statusTecnico: z.string().nullable(),
  lidoEm: z.string().nullable(),
  inicioPlanejado: dataNominal.nullable(),
  fimPlanejado: dataNominal.nullable(),
  estado: estadoDoVinculoDv360,
  conferidoEm: z.string().nullable(),
  naoEncontradoDesde: dataNominal.nullable(),
  /**
   * "Encerrar coleta" (P-34) VIGENTE: quando e por quê, como o usuário declarou. Nulo também depois de a coleta retomar
   * (então a declaração vem em `coletaRetomada`).
   */
  coletaEncerrada: z.object({ em: z.string(), motivo: z.string() }).nullable(),
  /**
   * A ÚLTIMA coleta encerrada que RETOMOU (P-34, §3.1; parte E, VT2-PC-04, DS-671 (r) e (t)): uma conferência posterior
   * voltou a encontrar a Campaign. A declaração fica como foi feita (`encerradaEm`, `motivo`); `retomadaEm` é o instante
   * da volta. Nulo com um "Encerrar coleta" vigente (um novo episódio: então vem `coletaEncerrada`) e na coleta que nunca
   * retomou. Ausente: a API anterior, que não o manda (aditivo).
   */
  coletaRetomada: z.object({ encerradaEm: z.string(), motivo: z.string(), retomadaEm: z.string() }).nullable().optional(),
  vinculadoPor: referenciaDeUsuario,
  vinculadoEm: z.string(),
  inicioCarga: dataNominal.nullable(),
  historicoLimitado: z.boolean(),
  /** A cobertura (união das janelas validadas): o trecho contínuo desde o início da carga, os blocos e as lacunas. */
  cobertura: z.object({
    desde: dataNominal.nullable(),
    ate: dataNominal.nullable(),
    blocos: z.array(intervaloDv360),
    lacunas: z.array(intervaloDv360),
  }),
  /** Confirmada e coberta sem buraco desde o início da carga. */
  completa: z.boolean(),
  sincronizacao: estadoDaSincronizacaoNaFichaDv360,
  /** A sincronização aberta agora, de qualquer origem e de qualquer usuário, à parte da situação derivada. */
  sincronizacaoEmCurso: sincronizacaoDv360.nullable().optional(),
  /** A última fechada (id, origem, estado, motivo e horários): o desfecho do pedido que a tela acompanha. */
  ultimaSincronizacao: sincronizacaoDv360.nullable().optional(),
  /** Os totais da Campaign no intervalo, dos fatos da cobertura dela (a mesma base do resumo); nulos sem cobertura. */
  totais: totaisDv360.nullable(),
  composto: leituraCompostaDv360.optional(),
  insertionOrders: z.number().int(),
  lineItems: z.number().int(),
  temAlerta: z.boolean(),
  capacidades: z.object({
    podeReconferir: z.boolean(),
    podeEncerrarColeta: z.boolean(),
    podeAmpliarHistorico: z.boolean(),
    podeTentarDeNovo: z.boolean(),
    podeDesvincular: z.boolean(),
    /** "Reprocessar período" (P-41): `midia · editar_todos`, integração ativa, Campaign confirmada e coletando. */
    podeReprocessar: z.boolean(),
  }),
})
export type CampaignDv360NaFicha = z.infer<typeof campaignDv360NaFicha>

export const fimDaSincronizacaoNaFichaDv360 = z.discriminatedUnion('tipo', [
  z.object({ tipo: z.literal('aberta') }),
  z.object({
    tipo: z.literal('delimitada'),
    /** O último dia de execução; depois dele, "Sincronização encerrada em dd/mm". */
    ate: dataNominal,
    encerrada: z.boolean(),
    noTeto: z.boolean(),
    ativaNoTeto: z.boolean(),
    retomada: z.boolean(),
  }),
])

export const associacaoDoConsolidadoDv360 = z.object({
  tipo: z.enum(['associado_ao_item', 'nao_distribuido', 'nao_associado', 'substituido', 'por_linha']),
  /** Os itens do pedido do grupo coberto (vazio em "não associado a itens"). */
  itens: z.array(uuid),
  /** "Substituído por apuração manual desde dd/mm". */
  desde: dataNominal.nullable(),
})

/** O bloco inteiro (§5.2): o resumo, os alertas, o fim delimitado, as Campaigns e as capacidades dos atos. */
export const midiaDv360DaCampanha = z.object({
  integracaoAtiva: z.boolean(),
  /** O parâmetro `dv360.sincronizacao_diaria_ativa`. */
  diariaAtiva: z.boolean(),
  moedaDaCampanha: z.string(),
  veCustos: z.boolean(),
  veQuantias: z.boolean(),
  /** O recorte pedido; nulo = Acumulado. */
  recorte: intervaloDv360.nullable(),
  resumo: z.object({
    estado: z.enum(['sem_vinculo', 'parcial', 'completo']),
    vinculadas: z.number().int(),
    /** k: as Campaigns confirmadas e cobertas desde o início da carga ("Parcial: k de n"). */
    completas: z.number().int(),
    /** X: "Completo até X" (no parcial, até onde as k completas vão). */
    ate: dataNominal.nullable(),
    /** O primeiro dia com veiculação do total ("Resultados de … a X"). */
    desde: dataNominal.nullable(),
    /**
     * "Dados desde": o primeiro dia coberto das Campaigns completas — o início efetivo da carga, ou antes dele quando a
     * cobertura já vinha de antes (o "desde" nunca fica antes dele; DS-672 (a)).
     */
    dadosDesde: dataNominal.nullable(),
    /** O intervalo que o total declara (o recorte limitado a X, ou de `desde` a X). */
    intervalo: intervaloDv360.nullable(),
    totais: totaisDv360,
    composto: leituraCompostaDv360.optional(),
    /** "Dados recentes parciais (k de n), de X+1 a Y": nunca somam ao total. */
    recentes: z.object({
      de: dataNominal, ate: dataNominal, campaignsCobrindo: z.number().int(), vinculadas: z.number().int(), totais: totaisDv360,
    }).nullable(),
    /** "Dos quais fora do período planejado" (da campanha local e das Campaigns no DV360): entra no total, só alerta. */
    foraDoPeriodo: z.object({
      local: z.object({ totais: totaisDv360, dias: z.array(dataNominal) }),
      campaign: z.object({ totais: totaisDv360, dias: z.array(dataNominal) }),
    }),
    /** O término do último relatório validado das Campaigns vinculadas (instante ISO). */
    ultimaAtualizacao: z.string().nullable(),
    /** Encerramento de sincronização concluída com relatório ingerido e validado, não finishTime do Google. */
    ultimaSincronizacaoConcluida: z.string().nullable().optional(),
    /** Como o consolidado entra no gasto (leitor de custo: nulo sem `midia_custos_margem · ver`, e sem vínculo). */
    associacao: associacaoDoConsolidadoDv360.nullable(),
  }),
  alertas: z.array(alertaDv360),
  fimDaSincronizacao: fimDaSincronizacaoNaFichaDv360,
  campaigns: z.array(campaignDv360NaFicha),
  limiteDeCampaigns: z.number().int(),
  /** Por que não pode vincular (P-58), o mesmo da ficha; nulo quando pode. */
  motivoSemVinculo: motivoSemVinculoDv360.nullable(),
  capacidades: z.object({
    podeVincular: z.boolean(),
    podeDesvincular: z.boolean(),
    /** Quem edita a campanha, integração ativa, alguma Campaign que possa sincronizar. */
    podeSincronizar: z.boolean(),
    /** Quem edita os custos, integração ativa, campanha com fim delimitado. */
    podeRetomarAcompanhamento: z.boolean(),
  }),
})
export type MidiaDv360DaCampanha = z.infer<typeof midiaDv360DaCampanha>

export const insertionOrderDv360NaFicha = z.object({
  insertionOrderId: z.string(),
  nome: z.string().nullable(),
  statusTecnico: z.string(),
  naoEncontradoDesde: dataNominal.nullable(),
  inicioPlanejado: dataNominal.nullable(),
  fimPlanejado: dataNominal.nullable(),
  lineItems: z.number().int(),
  totais: totaisDv360,
  composto: leituraCompostaDv360.optional(),
})
export type InsertionOrderDv360NaFicha = z.infer<typeof insertionOrderDv360NaFicha>

export const insertionOrdersDv360DaCampaign = z.object({
  campaignId: z.string(),
  /** O trecho contínuo coberto da Campaign (os totais vêm dele, no recorte). */
  coberto: intervaloDv360.nullable(),
  insertionOrders: z.array(insertionOrderDv360NaFicha),
})
export type InsertionOrdersDv360DaCampaign = z.infer<typeof insertionOrdersDv360DaCampaign>

export const lineItemDv360NaFicha = z.object({
  lineItemId: z.string(),
  insertionOrderId: z.string(),
  campaignId: z.string(),
  nome: z.string().nullable(),
  tipo: z.string().nullable(),
  statusTecnico: z.string(),
  naoEncontradoDesde: dataNominal.nullable(),
  /** Quantos criativos o LI usa (dos `creativeIds`, P-53): sem métrica por criativo. */
  criativos: z.number().int(),
  totais: totaisDv360,
  composto: leituraCompostaDv360.optional(),
  /** Sem atividade completa no recorte; com leitura=composta, considera também o retrato selecionado. */
  semAtividadeNoRecorte: z.boolean(),
})
export type LineItemDv360NaFicha = z.infer<typeof lineItemDv360NaFicha>

export const lineItemsDv360DoInsertionOrder = z.object({
  insertionOrderId: z.string(),
  campaignId: z.string(),
  pagina: z.number().int(),
  porPagina: z.number().int(),
  total: z.number().int(),
  /** Por Media Cost (quem vê as quantias) ou por impressões. */
  ordem: z.enum(['custo', 'impressoes']),
  lineItems: z.array(lineItemDv360NaFicha),
})
export type LineItemsDv360DoInsertionOrder = z.infer<typeof lineItemsDv360DoInsertionOrder>

export const escopoDaSerieDv360 = z.object({ nivel: z.enum(['campanha', 'campaign', 'io', 'li']), id: z.string().nullable() })

export const pontoDaSerieDv360 = z.object({
  /** `AAAA-MM-DD` (dia), `AAAA-Www` (semana ISO) ou `AAAA-MM` (mês). */
  chave: z.string(),
  de: dataNominal,
  ate: dataNominal,
  totais: totaisDv360,
  composto: leituraCompostaDv360.optional(),
  /** Quantas Campaigns cobrem o ponto inteiro: menos que `campaigns` é "dados parciais"; 0 é "sem cobertura". */
  cobertas: z.number().int(),
  campaigns: z.number().int(),
})

export const serieDv360 = z.object({
  grao: z.enum(['dia', 'semana', 'mes']),
  escopo: escopoDaSerieDv360,
  /** O intervalo da série (o recorte, ou dos dados mais antigos até o último dia coberto); nulo sem cobertura nenhuma. */
  intervalo: intervaloDv360.nullable(),
  pontos: z.array(pontoDaSerieDv360),
  /** Série no recorte completo/retrato, só com leitura=composta; até 367 pontos. O teto legado continua 366. */
  composta: z.object({ intervalo: intervaloDv360.nullable(), pontos: z.array(pontoDaSerieDv360) }).optional(),
})
export type SerieDv360 = z.infer<typeof serieDv360>

export const criativoDv360NaFicha = z.object({
  creativeId: z.string(),
  nome: z.string().nullable(),
  tipo: z.string(),
  statusTecnico: z.string(),
  hospedagem: z.string(),
  /**
   * "Usado em n line items deste escopo" (as Campaigns confirmadas da campanha; na listagem do escopo com filtros, só os
   * line items que passam neles — a Campaign, o IO, o tipo e o status do line item: VT2-PC-08); nunca métrica por criativo.
   */
  usadoEmLineItems: z.number().int(),
  lidoEm: z.string(),
})
export type CriativoDv360NaFicha = z.infer<typeof criativoDv360NaFicha>

export const criativosDv360DoLineItem = z.object({ lineItemId: z.string(), criativos: z.array(criativoDv360NaFicha) })
export type CriativosDv360DoLineItem = z.infer<typeof criativosDv360DoLineItem>

export const criativosDv360DoEscopo = z.object({
  pagina: z.number().int(),
  porPagina: z.number().int(),
  total: z.number().int(),
  criativos: z.array(criativoDv360NaFicha),
})
export type CriativosDv360DoEscopo = z.infer<typeof criativosDv360DoEscopo>
